/*
 * BBC - Rap Map - Video overlay component
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React, { useEffect, useRef } from 'react';
import ShareLinks from './ShareLinks';
import CloseButton from './CloseButton';

const Video = ({
    video: {
        video_poster: videoPoster,
        id,
        name,
        location,
        video_pid: videoPID,
        guidance,
    },
    setVideo,
    season
}) => {
    const mediaPlayerRef = useRef(0);
    const mediaContainerRef = useRef(0);

    const closeVideo = () => setVideo(null);

    useEffect(() => {
        if (id !== undefined && id !== "undefined") {
            window.history.pushState(
                null,
                null,
                `${window.location.origin}${window.location.pathname}?v=${id}&season=${season}`
            );
        }
    }, [id, season]);

    const keydownListener = e => {
        if (e.code === 'Escape') {
            closeVideo();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', keydownListener, true);
        return () => window.removeEventListener('keydown', keydownListener, true);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const bump = window.embeddedMedia?.api;
        const settings = {
            product: 'iplayer',
            responsive: true,
            counterName: 'smp.demopage.player.page',
            playlistObject: {
                "guidance": guidance ? guidance : '',
                'title': `Rap: ${name} at ${location}`,
                'holdingImageURL': `https://ichef.bbci.co.uk/images/ic/320xn/${videoPoster}.png`,
                'items': [
                    {
                        'versionID': videoPID,
                        'kind': 'programme',
                        'duration': 37
                    }
                ],
            },
            statsObject: { clipPID: 'p08ssk92' },
            ui: {
                "colour": season === 3 ? "#f05c89" : "#2CFF72",
            }
        };
        const mediaPlayer = bump?.player(mediaPlayerRef.current, settings);

        if (mediaPlayer) mediaPlayer.load();
    }, [mediaPlayerRef, videoPID, videoPoster, name, location, guidance, season]);

    const getVideoHeight = () => {
        if (mediaPlayerRef.current) {
            mediaContainerRef.current.style.height = `${mediaPlayerRef.current.offsetHeight}px`;
        }
    };

    useEffect(() => {
        getVideoHeight();
        window.addEventListener('resize', getVideoHeight, true);
        return () => window.removeEventListener('resize', getVideoHeight, true);
        // eslint-disable-next-line
    }, [mediaPlayerRef]);

    return (
        <div className="Video">
            <h2 className="vh">Video overlay container, for rapper {name} of {location}</h2>
            <div className="Video__Container" ref={mediaContainerRef}>
                <div className="Video__Wrapper">
                    <div id="mediaPlayer" className="Video__MediaPlayer" ref={mediaPlayerRef}> </div>
                </div>
                <CloseButton onClick={closeVideo} ariaText="Close Video Overlay" />
            </div>
            <ShareLinks />
        </div>
    );
};

export default Video;
